var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useRef, useCallback, useMemo } from 'react';
import { useRecordContext, useGetIdentity, useTranslate, useResourceContext, useNotify, useSaveContext, SaveContextProvider, } from 'react-admin';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField, } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useAddRevisionAfterMutation, REVISION_FIELD, } from './useAddRevisionAfterMutation';
import { detectChangedFields } from './utils/detectChangedFields';
export var CreateRevisionOnSave = function (props) {
    var _a;
    var _b = props || {}, children = _b.children, _c = _b.skipUserDetails, skipUserDetails = _c === void 0 ? false : _c;
    var record = useRecordContext(props);
    var resource = useResourceContext(props);
    if (!resource) {
        throw new Error('The CreateRevisionOnSave component must be used inside a ResourceContext or must be passed a resource prop.');
    }
    var originalSaveContext = useSaveContext();
    if (!originalSaveContext.save) {
        throw new Error('The CreateRevisionOnSave component must be used inside a SaveContext');
    }
    var identity = useGetIdentity().identity;
    var translate = useTranslate();
    var notify = useNotify();
    var resolve = useRef(undefined);
    var reject = useRef(undefined);
    //  form data
    var _d = useState(''), message = _d[0], setMessage = _d[1];
    var _e = useState(''), description = _e[0], setDescription = _e[1];
    var _f = useState(''), authorId = _f[0], setAuthorId = _f[1];
    // dialog state
    var _g = useState(false), open = _g[0], setOpen = _g[1];
    var messageFieldRef = useRef(null);
    var getMetadata = useCallback(function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var metadata;
        var _c, _d;
        var data = _b.data;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (skipUserDetails) {
                        return [2 /*return*/, Promise.resolve({
                                message: generateChangeMessage({
                                    changedFields: detectChangedFields(data, record),
                                    translate: translate,
                                    resource: resource,
                                    record: record,
                                }),
                                description: '',
                                authorId: (_c = identity === null || identity === void 0 ? void 0 : identity.id) !== null && _c !== void 0 ? _c : '',
                            })];
                    }
                    try {
                        setOpen(true);
                        setMessage(generateChangeMessage({
                            changedFields: detectChangedFields(data, record),
                            translate: translate,
                            resource: resource,
                            record: record,
                        }));
                        setAuthorId((_d = identity === null || identity === void 0 ? void 0 : identity.id) !== null && _d !== void 0 ? _d : '');
                        // Ensure the modal is rendered before focusing on the input
                        setTimeout(function () {
                            var _a;
                            (_a = messageFieldRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                        }, 0);
                    }
                    catch (e) {
                        console.error(e);
                    }
                    return [4 /*yield*/, new Promise(function (res, rej) {
                            // will be resolved by handleSubmit
                            resolve.current = res;
                            reject.current = rej;
                        })];
                case 1:
                    metadata = _e.sent();
                    setOpen(false);
                    return [2 /*return*/, metadata];
            }
        });
    }); }, [skipUserDetails, identity === null || identity === void 0 ? void 0 : identity.id, record, resource, translate]);
    // Ask for metadata before save and add a new revision after save
    useAddRevisionAfterMutation();
    var handleSubmit = function (event) {
        event.preventDefault();
        if (!message) {
            notify('ra-history.on_save.missing_revision_message', {
                _: 'Message is required',
                type: 'error',
            });
            return;
        }
        if (resolve.current)
            resolve.current({ message: message, description: description, authorId: authorId });
        setMessage('');
        setDescription('');
        setAuthorId('');
    };
    var handleClose = function () {
        setOpen(false);
        // as the form submission has already started, we must reject the promise to stop it
        if (reject.current)
            reject.current({ body: {} });
    };
    // Wrap the original save function so that we may ask for the revision data before saving
    var saveContext = useMemo(function () { return (__assign(__assign({}, originalSaveContext), { save: function (record, callbacks) { return __awaiter(void 0, void 0, void 0, function () {
            var _a, message, description, authorId, metadata, _b;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = {
                            message: undefined,
                            description: undefined,
                            authorId: undefined,
                        }, message = _a.message, description = _a.description, authorId = _a.authorId;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getMetadata({
                                resource: resource,
                                data: record,
                            })];
                    case 2:
                        metadata = _d.sent();
                        message = metadata.message;
                        description = metadata.description;
                        authorId = metadata.authorId;
                        return [3 /*break*/, 4];
                    case 3:
                        _b = _d.sent();
                        // the user cancelled the save operation
                        return [2 /*return*/];
                    case 4: return [2 /*return*/, originalSaveContext.save(__assign(__assign({}, record), (_c = {}, _c[REVISION_FIELD] = {
                            message: message,
                            description: description,
                            authorId: authorId,
                        }, _c)), callbacks)];
                }
            });
        }); } })); }, [getMetadata, resource, originalSaveContext]);
    if (skipUserDetails)
        return (_jsx(SaveContextProvider, { value: saveContext, children: children }));
    return (_jsxs(_Fragment, { children: [_jsx(SaveContextProvider, { value: saveContext, children: children }), _jsx(Dialog, { open: open, onClose: handleClose, fullWidth: true, maxWidth: "sm", children: _jsxs("form", { onSubmit: handleSubmit, children: [_jsx(DialogTitle, { children: translate('ra-history.on_save.title', {
                                _: 'Save Changes',
                            }) }), _jsx(IconButton, { "aria-label": "close", onClick: handleClose, sx: {
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: function (theme) { return theme.palette.grey[500]; },
                            }, children: _jsx(CloseIcon, {}) }), _jsxs(DialogContent, { children: [_jsx(TextField, { required: true, name: "message", label: translate('ra-history.on_save.message', {
                                        _: 'Revision message',
                                    }), fullWidth: true, variant: "filled", value: message, onChange: function (e) { return setMessage(e.target.value); }, inputRef: messageFieldRef }), _jsx(TextField, { name: "description", label: translate('ra-history.on_save.description', {
                                        _: 'Extended description',
                                    }), multiline: true, minRows: 3, fullWidth: true, variant: "filled", value: description, onChange: function (e) { return setDescription(e.target.value); } }), _jsx(TextField, { name: "authorName", label: translate('ra-history.on_save.author', {
                                        _: 'Author',
                                    }), fullWidth: true, variant: "filled", defaultValue: (_a = identity === null || identity === void 0 ? void 0 : identity.fullName) !== null && _a !== void 0 ? _a : '', disabled: true })] }), _jsxs(DialogActions, { sx: { pt: 2, pb: 2, pr: 3, pl: 0 }, children: [_jsx(Button, { onClick: handleClose, children: translate('ra.action.cancel', { _: 'Cancel' }) }), _jsx(Button, { type: "submit", variant: "contained", children: translate('ra.action.save', { _: 'Save' }) })] })] }) })] }));
};
var generateChangeMessage = function (_a) {
    var changedFields = _a.changedFields, translate = _a.translate, record = _a.record, resource = _a.resource;
    if (changedFields.length === 0) {
        if (!record || record.id === undefined) {
            return translate('ra-history.on_save.initial_changes', {
                _: 'Initial revision',
            });
        }
        else {
            return translate('ra-history.on_save.no_changes', {
                _: 'No changes',
            });
        }
    }
    if (changedFields.length === 1) {
        return translate('ra-history.on_save.one_change', {
            _: 'Changed %{field}',
            field: translate("resources.".concat(resource, ".fields.").concat(changedFields[0]), { _: changedFields[0] }),
        });
    }
    var modifiedFields = changedFields.map(function (field) {
        return translate("resources.".concat(resource, ".fields.").concat(field), { _: field });
    });
    return translate('ra-history.on_save.many_changes', {
        _: 'Changed %{fields}',
        fields: modifiedFields.join(', '),
    });
};
